import { createModule } from '../../createModule';
export const createBatchExecutorAPI = createModule(({ http }) => ({
    getInstanceQueues: async () => {
        const res = await http.get('/v2/batch_executor/instance_queues');
        return res;
    },
    getReportProgress: async () => {
        const res = await http.get('/v2/batch_executor/report_progress');
        return res;
    },
    getProcessDurations: async () => {
        const res = await http.get('/v2/batch_executor/process_duration');
        return res;
    },
    cloudPricing: {
        getState: async (params) => {
            const res = await http.get(`/v2/batch_executor/cloud-pricing/state/${params.instance_tag}`);
            return res;
        },
        start: async () => {
            const res = await http.post('/v2/batch_executor/cloud-pricing/start');
            return res;
        },
        stop: async () => {
            const res = await http.post('/v2/batch_executor/cloud-pricing/stop');
            return res;
        },
        reboot: async () => {
            const res = await http.post('/v2/batch_executor/cloud-pricing/reboot');
            return res;
        },
        runCustomStrategies: async (body) => {
            const res = await http.post('/v2/batch_executor/custom/strategies', { body: body });
            return res;
        },
        runVoldivAdjustments: async (body) => {
            const res = await http.post('/v2/batch_executor/custom/vol-div-adjustments', { body: body });
            return res;
        },
        runCalibration: async (body) => {
            const res = await http.post('/v2/batch_executor/cloud-pricing/calibrate', { body: body });
            return res;
        },
        runDefaultRisk: async (body) => {
            const res = await http.post('/v2/batch_executor/cloud-pricing/run-risk/default', {
                body: body,
            });
            return res;
        },
        runCustomRisk: async (body) => {
            const res = await http.post('/v2/batch_executor/cloud-pricing/run-risk/custom', {
                body: body,
            });
            return res;
        },
        runAllDefaultJobs: async (body) => {
            const res = await http.post('/v2/batch_executor/cloud-pricing/run-all/default', {
                body,
            });
            return res;
        },
        runDerivedMetrics: async (body) => {
            const res = await http.post('/v2/batch_executor/derived-metrics', { body });
            return res;
        },
    },
    sendBearScenarioEmail: async (params) => {
        const res = await http.post('/v2/batch_executor/bear-scenario/email', { body: params });
        return res;
    },
    rollRisk: async (params) => {
        const res = await http.post('/v2/risk/roll-risk', { body: params });
        return res;
    },
}));
